"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Colors = _interopRequireDefault(require("./Colors"));

var _Icon = _interopRequireDefault(require("./Icon"));

var RadioButtonCard = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RadioButtonCard, _React$Component);

  function RadioButtonCard() {
    (0, _classCallCheck2.default)(this, RadioButtonCard);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioButtonCard).apply(this, arguments));
  }

  (0, _createClass2.default)(RadioButtonCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          title = _this$props.title,
          value = _this$props.value;
      var _this$context$radioBu = this.context.radioButtonGroup,
          name = _this$context$radioBu.name,
          selectedValue = _this$context$radioBu.selectedValue,
          _onChange = _this$context$radioBu.onChange;
      var isChecked = value === selectedValue;
      return _react.default.createElement("label", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({
          'flex-1 relative cursor-pointer no-select margin-right-5 transition-all-short padding-top-4 padding-left-5 padding-right-6 padding-bottom-7': true
        }, className, className)),
        style: (0, _extends2.default)({
          borderColor: isChecked ? _Colors.default['blue'] : _Colors.default['grey-xl'],
          borderRadius: 12,
          borderStyle: isChecked ? 'solid' : 'dashed',
          borderWidth: 1
        }, style)
      }, _react.default.createElement("input", {
        className: "hidden",
        checked: isChecked,
        name: name,
        onChange: function onChange() {
          return _onChange(value);
        },
        type: "radio",
        style: {
          height: 0,
          width: 0
        }
      }), _react.default.createElement(_Icon.default, {
        className: (0, _classnames.default)({
          'float-right margin-top-3 margin-left-4': true,
          'grey-xl': !isChecked,
          'blue': isChecked
        }),
        icon: "ios-checkmark-circle-outline",
        fontSize: "3em"
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'font-size-5 margin-bottom-6': true,
          'grey-xl': !isChecked,
          'blue': isChecked
        })
      }, title), isChecked && children);
    }
  }]);
  return RadioButtonCard;
}(_react.default.Component);

;
RadioButtonCard.contextTypes = {
  radioButtonGroup: _propTypes.default.object
};
var _default = RadioButtonCard;
exports.default = _default;